// Generated by scripts/generate-mdi-icons.ts — do not edit. Run `npx tsx scripts/generate-mdi-icons.ts` after adding an icon.
import {
  mdiAccount,
  mdiAccountAlert,
  mdiAccountArrowRight,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiAccountKey,
  mdiAccountMultiple,
  mdiAccountMultiplePlus,
  mdiAccountOutline,
  mdiAccountPlus,
  mdiAccountPlusOutline,
  mdiAccountVoice,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiApi,
  mdiApplicationOutline,
  mdiArchiveArrowDownOutline,
  mdiArrowDown,
  mdiArrowLeft,
  mdiArrowRight,
  mdiBookOpenVariant,
  mdiCancel,
  mdiCardAccountDetailsOutline,
  mdiCart,
  mdiCashMultiple,
  mdiChatQuestionOutline,
  mdiCheck,
  mdiCheckAll,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckDecagram,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircleMedium,
  mdiCity,
  mdiClipboardCheckOutline,
  mdiClockAlert,
  mdiClockAlertOutline,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircleOutline,
  mdiCloseOctagon,
  mdiCloudSyncOutline,
  mdiCodeBraces,
  mdiCodeBrackets,
  mdiCogOutline,
  mdiCogs,
  mdiConsoleLine,
  mdiContentCopy,
  mdiCreditCard,
  mdiCreditCardOutline,
  mdiCube,
  mdiCurrencyUsd,
  mdiDelete,
  mdiDomain,
  mdiDownload,
  mdiDownloadOffOutline,
  mdiEarth,
  mdiEmail,
  mdiEmailCheckOutline,
  mdiEmailFast,
  mdiEmailOutline,
  mdiExitToApp,
  mdiEye,
  mdiEyeOff,
  mdiFaceAgent,
  mdiFileDocumentOutline,
  mdiFileOutline,
  mdiFilePdfBox,
  mdiFilter,
  mdiForum,
  mdiForumOutline,
  mdiGithub,
  mdiHeadset,
  mdiIncognito,
  mdiInformationOutline,
  mdiKey,
  mdiKeyChain,
  mdiKeyLink,
  mdiKeyPlus,
  mdiKeyVariant,
  mdiLicense,
  mdiLinkOff,
  mdiLockCheck,
  mdiLockOutline,
  mdiLockPlus,
  mdiLogout,
  mdiMagnify,
  mdiMailbox,
  mdiMapMarker,
  mdiMenuDown,
  mdiMenuRight,
  mdiMessageBulleted,
  mdiMonitorDashboard,
  mdiMonitorLock,
  mdiOpenInNew,
  mdiPackageVariantClosed,
  mdiPause,
  mdiPencil,
  mdiPencilPlus,
  mdiPhone,
  mdiPlus,
  mdiProfessionalHexagon,
  mdiQrcode,
  mdiReceiptTextOutline,
  mdiRefresh,
  mdiRestore,
  mdiRobotOutline,
  mdiSale,
  mdiSaleOutline,
  mdiSecurity,
  mdiSend,
  mdiServerNetwork,
  mdiShieldAccount,
  mdiShieldCheckOutline,
  mdiShieldCrown,
  mdiShieldLockOutline,
  mdiSourceBranch,
  mdiSubdirectoryArrowRight,
  mdiTagCheck,
  mdiTagMultipleOutline,
  mdiTagOutline,
  mdiTestTube,
  mdiThumbDownOutline,
  mdiThumbUpOutline,
  mdiTicketOutline,
  mdiTicketPercentOutline,
  mdiUpdate,
  mdiVectorPolyline,
  mdiViewDashboard,
  mdiWrench,
  mdiYoutube,
} from '@mdi/js';

/** SVG path of each MDI icon the site uses, by its `mdi-xxx` name. */
export const MDI_ICONS: Readonly<Record<string, string>> = {
  'mdi-account': mdiAccount,
  'mdi-account-alert': mdiAccountAlert,
  'mdi-account-arrow-right': mdiAccountArrowRight,
  'mdi-account-circle': mdiAccountCircle,
  'mdi-account-group': mdiAccountGroup,
  'mdi-account-key': mdiAccountKey,
  'mdi-account-multiple': mdiAccountMultiple,
  'mdi-account-multiple-plus': mdiAccountMultiplePlus,
  'mdi-account-outline': mdiAccountOutline,
  'mdi-account-plus': mdiAccountPlus,
  'mdi-account-plus-outline': mdiAccountPlusOutline,
  'mdi-account-voice': mdiAccountVoice,
  'mdi-alert': mdiAlert,
  'mdi-alert-circle': mdiAlertCircle,
  'mdi-alert-circle-outline': mdiAlertCircleOutline,
  'mdi-api': mdiApi,
  'mdi-application-outline': mdiApplicationOutline,
  'mdi-archive-arrow-down-outline': mdiArchiveArrowDownOutline,
  'mdi-arrow-down': mdiArrowDown,
  'mdi-arrow-left': mdiArrowLeft,
  'mdi-arrow-right': mdiArrowRight,
  'mdi-book-open-variant': mdiBookOpenVariant,
  'mdi-cancel': mdiCancel,
  'mdi-card-account-details-outline': mdiCardAccountDetailsOutline,
  'mdi-cart': mdiCart,
  'mdi-cash-multiple': mdiCashMultiple,
  'mdi-chat-question-outline': mdiChatQuestionOutline,
  'mdi-check': mdiCheck,
  'mdi-check-all': mdiCheckAll,
  'mdi-check-circle': mdiCheckCircle,
  'mdi-check-circle-outline': mdiCheckCircleOutline,
  'mdi-check-decagram': mdiCheckDecagram,
  'mdi-chevron-down': mdiChevronDown,
  'mdi-chevron-right': mdiChevronRight,
  'mdi-chevron-up': mdiChevronUp,
  'mdi-circle-medium': mdiCircleMedium,
  'mdi-city': mdiCity,
  'mdi-clipboard-check-outline': mdiClipboardCheckOutline,
  'mdi-clock-alert': mdiClockAlert,
  'mdi-clock-alert-outline': mdiClockAlertOutline,
  'mdi-clock-outline': mdiClockOutline,
  'mdi-close': mdiClose,
  'mdi-close-circle-outline': mdiCloseCircleOutline,
  'mdi-close-octagon': mdiCloseOctagon,
  'mdi-cloud-sync-outline': mdiCloudSyncOutline,
  'mdi-code-braces': mdiCodeBraces,
  'mdi-code-brackets': mdiCodeBrackets,
  'mdi-cog-outline': mdiCogOutline,
  'mdi-cogs': mdiCogs,
  'mdi-console-line': mdiConsoleLine,
  'mdi-content-copy': mdiContentCopy,
  'mdi-credit-card': mdiCreditCard,
  'mdi-credit-card-outline': mdiCreditCardOutline,
  'mdi-cube': mdiCube,
  'mdi-currency-usd': mdiCurrencyUsd,
  'mdi-delete': mdiDelete,
  'mdi-domain': mdiDomain,
  'mdi-download': mdiDownload,
  'mdi-download-off-outline': mdiDownloadOffOutline,
  'mdi-earth': mdiEarth,
  'mdi-email': mdiEmail,
  'mdi-email-check-outline': mdiEmailCheckOutline,
  'mdi-email-fast': mdiEmailFast,
  'mdi-email-outline': mdiEmailOutline,
  'mdi-exit-to-app': mdiExitToApp,
  'mdi-eye': mdiEye,
  'mdi-eye-off': mdiEyeOff,
  'mdi-face-agent': mdiFaceAgent,
  'mdi-file-document-outline': mdiFileDocumentOutline,
  'mdi-file-outline': mdiFileOutline,
  'mdi-file-pdf-box': mdiFilePdfBox,
  'mdi-filter': mdiFilter,
  'mdi-forum': mdiForum,
  'mdi-forum-outline': mdiForumOutline,
  'mdi-github': mdiGithub,
  'mdi-headset': mdiHeadset,
  'mdi-incognito': mdiIncognito,
  'mdi-information-outline': mdiInformationOutline,
  'mdi-key': mdiKey,
  'mdi-key-chain': mdiKeyChain,
  'mdi-key-link': mdiKeyLink,
  'mdi-key-plus': mdiKeyPlus,
  'mdi-key-variant': mdiKeyVariant,
  'mdi-license': mdiLicense,
  'mdi-link-off': mdiLinkOff,
  'mdi-lock-check': mdiLockCheck,
  'mdi-lock-outline': mdiLockOutline,
  'mdi-lock-plus': mdiLockPlus,
  'mdi-logout': mdiLogout,
  'mdi-magnify': mdiMagnify,
  'mdi-mailbox': mdiMailbox,
  'mdi-map-marker': mdiMapMarker,
  'mdi-menu-down': mdiMenuDown,
  'mdi-menu-right': mdiMenuRight,
  'mdi-message-bulleted': mdiMessageBulleted,
  'mdi-monitor-dashboard': mdiMonitorDashboard,
  'mdi-monitor-lock': mdiMonitorLock,
  'mdi-open-in-new': mdiOpenInNew,
  'mdi-package-variant-closed': mdiPackageVariantClosed,
  'mdi-pause': mdiPause,
  'mdi-pencil': mdiPencil,
  'mdi-pencil-plus': mdiPencilPlus,
  'mdi-phone': mdiPhone,
  'mdi-plus': mdiPlus,
  'mdi-professional-hexagon': mdiProfessionalHexagon,
  'mdi-qrcode': mdiQrcode,
  'mdi-receipt-text-outline': mdiReceiptTextOutline,
  'mdi-refresh': mdiRefresh,
  'mdi-restore': mdiRestore,
  'mdi-robot-outline': mdiRobotOutline,
  'mdi-sale': mdiSale,
  'mdi-sale-outline': mdiSaleOutline,
  'mdi-security': mdiSecurity,
  'mdi-send': mdiSend,
  'mdi-server-network': mdiServerNetwork,
  'mdi-shield-account': mdiShieldAccount,
  'mdi-shield-check-outline': mdiShieldCheckOutline,
  'mdi-shield-crown': mdiShieldCrown,
  'mdi-shield-lock-outline': mdiShieldLockOutline,
  'mdi-source-branch': mdiSourceBranch,
  'mdi-subdirectory-arrow-right': mdiSubdirectoryArrowRight,
  'mdi-tag-check': mdiTagCheck,
  'mdi-tag-multiple-outline': mdiTagMultipleOutline,
  'mdi-tag-outline': mdiTagOutline,
  'mdi-test-tube': mdiTestTube,
  'mdi-thumb-down-outline': mdiThumbDownOutline,
  'mdi-thumb-up-outline': mdiThumbUpOutline,
  'mdi-ticket-outline': mdiTicketOutline,
  'mdi-ticket-percent-outline': mdiTicketPercentOutline,
  'mdi-update': mdiUpdate,
  'mdi-vector-polyline': mdiVectorPolyline,
  'mdi-view-dashboard': mdiViewDashboard,
  'mdi-wrench': mdiWrench,
  'mdi-youtube': mdiYoutube,
};
